module.exports = __webpack_public_path__ + "static/media/id.e32caa42.svg";